<template>
    <div>
        <b-row>
            <b-col sm="12">
                <b-card no-body>
                    <b-card-header>
                        <span class="h5">
                            FORNECEDOR -
                            <b-badge variant="warning">{{ operacao }}</b-badge>
                            <b-button
                                variant="danger"
                                @click.stop="voltar()"
                                class="float-right btn-sm"
                            >
                                <span>
                                    <i class="fa fa-history"></i> Voltar
                                </span>
                            </b-button>
                        </span>
                    </b-card-header>
                    <b-card-body>
                        <app-k-v
                            :titulo="
                                fornecedor.cpfCnpj.length == 11 ? 'CPF' : 'CNPJ'
                            "
                            :md="3"
                            :lg="2"
                            :xl="1"
                            :dado="$maskCpfCnpj(fornecedor.cpfCnpj)"
                        ></app-k-v>
                        <app-k-v
                            :titulo="
                                fornecedor.cpfCnpj.length == 11
                                    ? 'Nome'
                                    : 'Razão Social'
                            "
                            :md="3"
                            :lg="2"
                            :xl="1"
                            :dado="fornecedor.razaoSocial"
                        ></app-k-v>
                        <ultimo-acesso
                            :ultimoAcesso="ultimoAcesso"
                            v-if="ultimoAcesso"
                        ></ultimo-acesso>
                    </b-card-body>
                    <!-- <b-card-footer>
                        <b-button variant="danger" @click.stop="voltar()" class="mr-2">
                            <span>
                                <i class="fa fa-history"></i> Voltar
                            </span>
                        </b-button>
                    </b-card-footer>-->
                </b-card>
            </b-col>
        </b-row>
        <fornecedores-dashboard
            v-if="mostrarDash"
            :fornecedorId="fornecedor.fornecedorId"
            @atualizarFornecedor="atualizarFornecedor($event)"
        ></fornecedores-dashboard>
        <router-view
            v-if="fornecedor.fornecedorId"
            :fornecedorId="fornecedor.fornecedorId"
            :dataServico="obterFornecedoresServicos()"
            :gestaoInterna="true"
        ></router-view>
    </div>
</template>

<script>
import FornecedoresServicos from './FornecedoresServicos'
import FornecedoresDashboard from './FornecedorDashboard'
import UltimoAcesso from './UltimoAcesso'

export default {
    props: {
        fornecedor: {
            type: Object,
            default: () => {}
        }
    },

    components: { FornecedoresDashboard, UltimoAcesso },

    data() {
        return {
            operacao: 'DETALHAR',
            erros: [],
            ultimoAcesso: null
        }
    },

    methods: {
        voltar() {
            if (this.$route.name != 'Fornecedores_Detalhar') {
                this.$router.push({ name: 'Fornecedores_Detalhar' })
            } else {
                this.$router.push({ name: 'Fornecedores' })
            }
        },

        obterFornecedoresServicos() {
            return FornecedoresServicos
        },

        atualizarFornecedor(dado) {
            this.ultimoAcesso = dado ? this.$moment(dado) : null
        }
    },

    computed: {
        mostrarDash() {
            return this.$route.name == 'Fornecedores_Detalhar'
        }
    },

    created() {},

    watch: {}
}
</script>
